import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function Login() {
  const { user, isAdmin } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");

  if (user && isAdmin) return <Navigate to="/admin" replace />;
  if (user && !isAdmin) return <div style={{padding:24}}>تم تسجيل الدخول، لكن هذا الحساب غير مخوّل للوصول للوحة التحكم.</div>;

  async function handleLogin(e) {
    e.preventDefault();
    setErr("");
    try {
      await signInWithEmailAndPassword(auth, email.trim(), pass);
      nav("/admin", { replace: true });
    } catch (e) {
      setErr(e.message || "فشل تسجيل الدخول");
    }
  }

  return (
    <div style={{maxWidth:380, margin:"60px auto", background:"#073c3d", padding:24, borderRadius:12, color:"#eafff7"}}>
      <h2 style={{marginTop:0}}>تسجيل الدخول</h2>
      <form onSubmit={handleLogin}>
        <input
          style={inp}
          type="email"
          placeholder="البريد"
          value={email}
          onChange={e=>setEmail(e.target.value)}
        />
        <input
          style={inp}
          type="password"
          placeholder="كلمة المرور"
          value={pass}
          onChange={e=>setPass(e.target.value)}
        />
        {err && <div style={{color:"#ffb3b3", marginBottom:8}}>{err}</div>}
        <button style={btn} type="submit">دخول</button>
      </form>
    </div>
  );
}

const inp = {width:"100%", padding:"12px 14px", margin:"8px 0", borderRadius:10, border:"1px solid #0d6d6f", outline:"none"};
const btn = {width:"100%", padding:"12px 14px", border:"none", borderRadius:10, background:"#0aa37f", color:"#fff", cursor:"pointer"};
